import tw from "twin.macro";

export const Notice = tw.div`tw-sticky tw-bottom-0 tw-left-0 tw-right-0 tw-py-1 tw-bg-teal-400 tw-text-center tw-mt-auto tw-mb-auto tw-font-bold tw-z-[5000] tw-text-sm`;
